import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";

interface GlobalSearchButtonProps {
  onClick: () => void;
}

export const GlobalSearchButton = ({ onClick }: GlobalSearchButtonProps) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      className="relative h-9 w-9 md:w-72 md:px-4 md:pr-12 text-muted-foreground justify-start"
    >
      <Search className="h-4 w-4 md:mr-2" />
      <span className="hidden md:inline-flex">Search patients...</span>
      <kbd className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 hidden md:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
        ⌘K
      </kbd>
    </Button>
  );
};
